<template>
  <div xs12 sm12 md12 lg12 xl12 v-if="fullscreen">
    <v-layout row>
      <v-flex ref="graphContainer">
        <GChart type="PieChart" :data="chartData" :options="chartOptions" />
      </v-flex>
    </v-layout>
  </div>
  <div px-2 mb-3 v-else>
    <v-card class="widget pa-0" :class="widgetStyle">
      <widget-header
        :widget="metricWidget"
        v-on:fullscreen="goFullScreen"
        v-if="!fullscreen"
      ></widget-header>
      <v-layout row class="pa-1"  :class="widgetHeight">
        <v-flex xs12 align-self-end>
          <GChart type="PieChart" :data="chartData" :options="chartOptions" />
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import "@/assets/styles/styles.css";
import WidgetHeader from "@/components/metrics/WidgetHeader.vue";
import { GChart } from "vue-google-charts";
import WidgetMixin from "@/components/metrics/WidgetMixin.js"

export default {
  name: "PiechartWidget",
  mixins: [WidgetMixin], 
  components: { WidgetHeader, GChart },
  computed: {
    chartOptions() {
      const options = {};
      if (this.fullscreen) {
        options.width = "100%";
        options.height = window.innerHeight - 72;
        options.pieSliceText = "label";
        options.legend = "none";
        options.theme = "maximized";
      } else {
        options.width = "100%";
        options.height = 140*this.metricWidget.height;
        options.theme = null;
        options.chartArea = {
          width: "90%",
          height: ["76%", "85%", "90%"][this.metricWidget.height-1]
        }         
      }
      if (this.widgetStyle === 'widget-style-blue') {
        options.legend = {
          textStyle: { color: '#fff' }
        }
      }
      options.pieHole = 0.1;
      options.backgroundColor = { fill: "transparent" };

      return options;
    },
  },
};
</script>